import { styledComponent } from '@hermes/web-components'

export const StyledContainer = styledComponent('div')`
  height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const StyledText = styledComponent('span')`
  font-weight: 500;
  font-size: 15px;
  color: #11245A;
  text-wrap: nowrap;
  `

export const ImageContainer = styledComponent('div')`
  width: 22px;
  heigth: 22px;
  `
